import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { parseUrlBySlash, splitUrlBySlashOrHash } from './util';

interface BreadcrumbPropsType {
  nameList: string[];
  path: string;
}

export const BreadcrumbJSONLD: (props: BreadcrumbPropsType) => JSX.Element | null = (props) => {
  const { path, nameList } = props;

  const url = path;
  const urlList = parseUrlBySlash(url);
  const splicedUrl = splitUrlBySlashOrHash(url);

  if (!urlList.length) {
    return null;
  }

  const crumbList = [];
  for (let index = 0; index < urlList.length && index < nameList.length; index++) {
    crumbList.push({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Thing',
        '@id': urlList[index],
        name: nameList[index] || splicedUrl[index],
      },
    });
  }
  return (
    <DynamicHead>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: crumbList,
          }),
        }}
      ></script>
    </DynamicHead>
  );
};
